import { NavBar, PullToRefresh, Popup, Toast } from 'antd-mobile'
import React, { useCallback, useEffect, useState } from 'react'
import API_ROUTES from '../api'
import axios from 'axios'
import Icon from '../icon'
import { DownOutline, RightOutline } from 'antd-mobile-icons'
import './index.css'

export default function Confrontation() {

    const [seasonInfo, setSeansonInfo] = useState([])
    const [currentSeasonInfo, setCurrentSeasonInfo] = useState(null)
    const [filterVisible, setFilterVisible] = useState(false);

    const [captainSeasonInfo, setCaptainSeasonInfo] = useState({})
    // Stores which captain cards are expanded
    const [expandedCaptains, setExpandedCaptains] = useState([])

    const toggleCaptain = (captainId) => {
        setExpandedCaptains(prev => {
            if (prev.includes(captainId)) {
                return prev.filter(id => id !== captainId)
            } else {
                return [...prev, captainId]
            }
        })
    }

    const getCaptainSeasonInfo = useCallback(() => {
        if (!currentSeasonInfo) return;

        axios.get(API_ROUTES.game_getCaptainSeasonInfo, {
            params: {
                seasonId: currentSeasonInfo
            }
        }, null)
            .then(function (response) {
                const resultData = response.data.data
                setCaptainSeasonInfo(resultData)
                // Expand all by default
                setExpandedCaptains(resultData?.captainDetailInfoList?.map(item => item.captainId))
                Toast.clear()
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [currentSeasonInfo])

    const getSeasonListInfo = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0
        })
        axios.get(API_ROUTES.season_list, {
        }, null)
            .then(function (response) {
                const result = response.data.data
                if (result.length > 0) {
                    setSeansonInfo(result)
                    const firstSeason = result.find(item => item.isFirst === 1)
                    setCurrentSeasonInfo(firstSeason?.id)
                }
                Toast.clear()
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: "服务错误！请联系管理员！"
                })
            })
    }, [])

    useEffect(() => {
        getSeasonListInfo()
    }, [getSeasonListInfo])

    useEffect(() => {
        if (currentSeasonInfo) {
            getCaptainSeasonInfo()
        }
    }, [currentSeasonInfo, getCaptainSeasonInfo])

    const renderOpponentDetails = (memberInfo) => {
        const formatMonthDay = (timestamp) => {
            const date = new Date(timestamp);
            const month = date.getMonth() + 1;
            const day = date.getDate();
            return `${month}/${day}`;
        };

        const parseMap = () => {
            const entriesWithLatestTime = Object.entries(memberInfo.confrontationDetailInfoMap || {})
                .map(([key, value]) => {
                    if (!value || value.length === 0) {
                        return { key, value, latestMatchTime: new Date(0) };
                    }
                    const latestMatch = value.reduce((prev, curr) => {
                        return new Date(curr.matchTime) > new Date(prev.matchTime) ? curr : prev;
                    });
                    return {
                        key,
                        value,
                        latestMatchTime: new Date(latestMatch.matchTime)
                    };
                });

            const sortedEntries = entriesWithLatestTime.sort((a, b) => {
                return b.latestMatchTime - a.latestMatchTime;
            });

            return sortedEntries.map(({ key, value }, index) => {
                const opponentMatches = value?.sort((a, b) => new Date(b.matchTime) - new Date(a.matchTime));

                return (
                    <div key={key + index} className="conf-opponent-item">
                        <div className="conf-opponent-header">
                            <img src={Icon.VS_LOGO} style={{ width: '14px', opacity: 0.8 }} alt="vs" />
                            <span className="conf-opponent-name" style={{ fontSize: '13px', color: '#1D2129' }}>{key}</span>
                            <span style={{ fontSize: '11px', color: '#86909C' }}>({opponentMatches?.length}场)</span>
                        </div>

                        <div className="conf-match-scroller">
                            {opponentMatches?.map((item, mIndex) => {
                                const isCaptainGreen = item.greenCaptain === memberInfo.captainId;
                                const myGoal = isCaptainGreen ? item.greenGoal : item.redGoal;
                                const oppGoal = isCaptainGreen ? item.redGoal : item.greenGoal;

                                let status = 'draw';
                                if (myGoal > oppGoal) status = 'win';
                                if (myGoal < oppGoal) status = 'lose';

                                return (
                                    <div key={item.id || mIndex} className={`conf-match-pill ${status}`}>
                                        <span className="conf-pill-score">
                                            {myGoal}:{oppGoal}
                                        </span>
                                        <span className="conf-pill-date">{formatMonthDay(item.matchTime)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            });
        };

        return (
            <div className="conf-details-box">
                <div className="conf-summary-row">
                    <div className="conf-stat-item">
                        <span className="conf-stat-value" style={{ color: '#34d399', fontSize: '16px' }}>{memberInfo.totalGet}</span>
                        <span className="conf-stat-label">进球</span>
                    </div>
                    <div className="conf-stat-item">
                        <span className="conf-stat-value" style={{ color: '#f87171', fontSize: '16px' }}>{memberInfo.totalLose}</span>
                        <span className="conf-stat-label">失球</span>
                    </div>
                    <div className="conf-stat-item">
                        <span className="conf-stat-value" style={{ fontSize: '16px' }}>{memberInfo.totalGet - memberInfo.totalLose}</span>
                        <span className="conf-stat-label">净胜</span>
                    </div>
                </div>
                {parseMap()}
            </div>
        )
    }

    const getCurrentSeasonName = () => {
        if (!seasonInfo.length) return '加载中...'
        const s = seasonInfo.find(item => item.id === currentSeasonInfo)
        return s ? s.seasonName : '选择赛季'
    }

    return (
        <div className="conf-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                对抗统计
            </NavBar>

            {/* Merged Header: Stats + Filter */}
            <div className="conf-header-box">
                <div className="conf-quick-stats">
                    <div className="conf-quick-stat-item">
                        <span className="conf-quick-label">总场次</span>
                        <span className="conf-quick-value">{captainSeasonInfo.totalCount || 0}</span>
                    </div>
                    <div className="conf-quick-stat-item">
                        <span className="conf-quick-label">总进球</span>
                        <span className="conf-quick-value" style={{ color: '#fbbf24' }}>{captainSeasonInfo.totalGoal || 0}</span>
                    </div>
                </div>

                <div
                    className="conf-filter-btn"
                    onClick={() => setFilterVisible(true)}
                >
                    <span>{getCurrentSeasonName()}</span>
                    <DownOutline fontSize={10} />
                </div>
            </div>

            <PullToRefresh
                onRefresh={async () => {
                    await getCaptainSeasonInfo()
                }}>

                <div className="conf-accordion-container">
                    {captainSeasonInfo?.captainDetailInfoList?.map(item => {
                        const isExpanded = expandedCaptains.includes(item.captainId);

                        return (
                            <div
                                key={item.captainId}
                                className={`conf-captain-card ${isExpanded ? 'expanded' : ''}`}
                            >
                                <div
                                    className="conf-captain-header"
                                    onClick={() => toggleCaptain(item.captainId)}
                                >
                                    {/* Single Line Flex Row */}
                                    <div className="conf-captain-info-row">
                                        <span className="conf-captain-name">
                                            {item.captainName}
                                        </span>
                                        <div className="conf-captain-badges">
                                            <span className="conf-stat-badge">
                                                <img src={Icon.CHANGCI} style={{ width: '12px' }} alt="" />
                                                {item.totalCount}
                                            </span>
                                            <span className="conf-stat-badge">
                                                <img src={Icon.JIFENXINGBIAO} style={{ width: '12px' }} alt="" />
                                                {item.integral}
                                            </span>
                                            <span className="conf-win-rate">
                                                <span className="stat-win">{item.totalWin}</span>/
                                                <span className="stat-draw">{item.totalDraw}</span>/
                                                <span className="stat-lose">{item.totalFail}</span>
                                            </span>
                                        </div>
                                    </div>
                                    <RightOutline className={`conf-arrow ${isExpanded ? 'rotated' : ''}`} />
                                </div>

                                <div className="conf-accordion-content">
                                    {renderOpponentDetails(item)}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </PullToRefresh>

            <Popup
                visible={filterVisible}
                onMaskClick={() => setFilterVisible(false)}
                bodyClassName="conf-popup-body"
                bodyStyle={{ maxHeight: '60vh', overflowY: 'auto' }}
            >
                <div className="conf-popup-header">选择赛季</div>
                <div className="conf-season-list">
                    {seasonInfo?.map(item => (
                        <div
                            key={item.id}
                            className={`conf-season-item ${currentSeasonInfo === item.id ? 'active' : ''}`}
                            onClick={() => {
                                setCurrentSeasonInfo(item.id);
                                setFilterVisible(false);
                            }}
                        >
                            {item.seasonName}
                        </div>
                    ))}
                </div>
            </Popup>
        </div>
    )
}
